export default __webpack_public_path__ + "static/media/getting_started2.daa8ebcb.png";